import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const DataTableWidgetV4: WidgetRegistryEntry = {
  name: "DataTableV4",
  component: () => import("./data-table-widget-v4.component").then((m) => m.DataTableWidgetV4Component),
  configuration: () => import("./configuration").then((m) => m.DataTableWidgetV4Configuration)
};
